export default {"src":"/_next/static/media/03_Gift_PT.b2c70bf9.gif","height":261,"width":267};